/* eslint-disable max-lines */
import { IMusicApi } from '@/modules/musicCards/mappers/get/fromApi';

export const dataMusic: IMusicApi[] = [
  {
    id: 'gyRs_zZ1deQ',
    title: 'Paula Fernandes - Paixão De Mulher',
    artist: 'Paula Fernandes',
  },

  {
    id: 'qUMBS7hYRu4',
    title: 'SAMURAI - Never Fade Away (Cyberpunk 2077 107.3 Morro Rock Radio)',
    artist: 'Choomba',
  },

  {
    id: 'A5Oz9pIR5Bw',
    title: 'GAROTA NACIONAL',
    artist: 'SKANK',
  },

  {
    id: '7Ie4oL17Nwc',
    title: 'É Uma Partida De Futebol',
    artist: 'Skank',
  },

  {
    id: 'bVCrT5JZqo0',
    title: 'Era um garoto que Como Eu Amava os Beatles e os Rolling Stones(Acústico MTV)',
    artist: 'Engenheiros do Hawaii',
  },

  {
    id: '0mYBSayCsH0',
    title: "I'm A Believer",
    artist: 'Smash Mouth',
  },

  {
    id: 'CN5FEqnJdmc',
    title: 'Fiorino',
    artist: 'Gabriel Gava',
  },

  {
    id: 'x4tz18jNMr0',
    title: 'Glamurosa',
    artist: 'Mc Marcinho',
  },

  {
    id: 'XfUo2mPYQ2E',
    title: 'CYBERPUNK 2077 - RESIST AND DISORDER by Rezodrone (Jason Charles Miller & Jamison Boaz)',
    artist: 'Lakeshore Records',
  },

  {
    id: 'o1tj2zJ2Wvg',
    title: 'Welcome To The Jungle',
    artist: 'Guns N Roses',
  },

  {
    id: 'tIUBzJ7p1e0',
    title: 'É preciso saber viver',
    artist: 'TITÃS',
  },

  {
    id: 'FACcSz6wH30',
    title: 'VIDA DE EMPREGUETES (CLIPE OFICIAL) 2012',
    artist: 'Cheias De Charme',
  },

  {
    id: 'wMsazR6Tnf8',
    title: "I Love Rock 'n' Roll",
    artist: 'Joan Jett and the Blackhearts',
  },

  {
    id: 'cus-lGN0vds',
    title: 'COITADO',
    artist: 'Naiara Azevedo',
  },

  {
    id: 'X4bgXH3sJ2Q',
    title: 'The Trooper (Official Video)',
    artist: 'Iron Maiden',
  },

  {
    id: 'AOPMlIIg_38',
    title: 'Boom Clap',
    artist: 'Charli XCX',
  },

  {
    id: 'wo4pWZApd2Y',
    title: 'Deixa Acontecer (Ao Vivo)',
    artist: 'Grupo Revelação',
  },

  {
    id: '0qanF-91aJo',
    title: 'Paranoid',
    artist: 'BLACK SABBATH',
  },
  {
    id: 'O8zLeTdudIo',
    title: ' Just Like You',
    artist: 'Hannah Montana',
  },

  {
    id: 'aSugSGCC12I',
    title: 'Manchild (Official Video)',
    artist: 'Sabrina Carpenter',
  },

  {
    id: 'wn_7FY82uP0',
    title: 'Regime Fechado',
    artist: 'Simone & Simaria',
  },

  {
    artist: 'Message to Bears & Will Samson',
    title: 'Mountains',
    id: 'oVDOet85uoU',
  },

  {
    artist: 'Celly Campello',
    title: 'Estúpido Cupido',
    id: 'unwkZNfAfBc',
  },

  {
    artist: 'Abba',
    title: 'Mamma Mia (Official Music Video)',
    id: 'unfzfe8f9NI',
  },
  {
    artist: 'Post Malone',
    title: 'Circles',
    id: 'wXhTHyIgQ_U',
  },
  {
    artist: 'Noisettes',
    title: 'Never Forget You',
    id: 'KRFHiBW9RE8',
  },
  {
    artist: 'Sapão',
    title: 'Vou Desafiar Você (Clipe Oficial)',
    id: 'W6f8jlqRXB4',
  },
  {
    artist: "K'NAAN",
    title: "Wavin' Flag (Coca-Cola Celebration Mix)",
    id: 'WTJSt4wP2ME',
  },
  {
    artist: 'MC Leozinho',
    title: 'Se Ela Dança Eu Danço',
    id: 'SNkhZ-RMB7Y',
  },
  {
    artist: 'Yves Larock',
    title: 'Rise Up',
    id: 'vSvrf84UjFg',
  },
  {
    artist: 'Avicii',

    title: 'Without You "Audio"',
    id: 'WRz2MxhAdJo',
  },
  {
    artist: 'Anna Catarina',
    title: 'Nem Tchum',
    id: 'R7Il9VCTt2E',
  },
  {
    artist: 'BØRNS',
    title: 'Past Lives',
    id: 'VDrwssKZPaw',
  },
  {
    artist: 'Lucy Thomas',
    title: 'Hallelujah',
    id: '4hjgkvuKES8',
  },
  {
    artist: 'a banda mais bonita da cidade (c/ leo fressato)',
    title: 'oração',
    id: 'QW0i1U4u0KE',
  },
  {
    artist: 'Led Zeppelin',
    title: 'Immigrant Song',
    id: 'P3Y8OWkiUts',
  },
  {
    artist: 'Seal',
    title: 'Stand by Me (Live)',
    id: 'OINw340XQbg',
  },
  {
    artist: 'Banda Os Normais Musica',
    title: 'Vá Embora.',
    id: 'SxHk_XOA1kE',
  },
  {
    artist: 'P.O. Box',
    title: 'Papo de Jacaré',
    id: 'lMqeL99vwaY',
  },
  {
    artist: 'Post Malone, Swae Lee',
    title: 'Sunflower (Spider-Man: Into the Spider-Verse)',
    id: 'ApXoWvfEYVU',
  },
  {
    artist: 'Maduk ft Veela',
    title: 'Ghost Assassin',
    id: 'tEcggRukZCs',
  },
  {
    artist: 'The Wanted',
    title: 'Glad You Came',
    id: '2ggzxInyzVE',
  },
  {
    artist: 'Legião Urbana',
    title: 'Eduardo e Mônica',
    id: 'bsutUab2fkI',
  },
  {
    artist: 'Amado Batista',
    title: 'O Fruto Do Nosso Amor (Amor Perfeito)',
    id: 'vusZcitPsrY',
  },
  {
    artist: 'Amado Batista & Simone & Simaria',
    title: 'Folha Seca',
    id: 'auF-ZZQmNRY',
  },
  {
    artist: 'Lykke Li',
    title: 'I Follow Rivers',
    id: 'K3JGxj2rvAs',
  },
  {
    artist: 'Boney M.',
    title: 'Rivers of Babylon',
    id: 'l3QxT-w3WMo',
  },
  {
    artist: 'Joelma',
    title: 'Voando Pro Pará',
    id: 'wR3jqHayULY',
  },
  {
    artist: 'Tieta',
    title: 'Tieta',
    id: 'VwQAx5c6X2M',
  },
  {
    artist: 'Latino e Perlla',
    title: 'Selinho na Boca',
    id: 'N0jPJfQ_2hs',
  },
  {
    artist: 'Jão',
    title: 'Idiota',
    id: 'h27qhWrgXIg',
  },

  {
    artist: 'Dilson Monteiro',
    title: 'Eterno Amor',
    id: 'uQcrJI8l6ZA',
  },
  {
    artist: 'João Gomes e Vanessa da Mata',
    title: 'SÓ VOCÊ E EU / AMADO',
    id: 'RXrYjpFU8Tg',
  },
  {
    artist: 'The Black Eyed Peas',
    title: 'I Gotta Feeling',
    id: 'uSD4vsh1zDA',
  },
  {
    artist: 'Gnarls Barkley',
    title: 'Crazy',
    id: '-N4jf6rtyuw',
  },
  {
    artist: 'P!nk',
    title: 'Get the Party Started',
    id: 'mW1dbiD_zDk',
  },
  {
    artist: 'Kelly Clarkson',
    title: "Stronger (What Doesn't Kill You)",
    id: 'Xn676-fLq7I',
  },
  {
    artist: 'Ultraje a Rigor',
    title: 'Nós Vamos Invadir sua Praia',
    id: 'VJNill3YOcs',
  },
  {
    artist: 'Harry Nilsson',
    title: 'Without You',
    id: 'G-ZDKirjQgM',
  },
  {
    artist: 'Tears For Fears',
    title: 'Mad World',
    id: 'u1ZvPSpLxCg',
  },
  {
    artist: 'Kim Carnes',
    title: 'Bette Davis Eyes',
    id: 'EPOIS5taqA8',
  },
  {
    artist: 'James Blunt',
    title: "You're Beautiful",
    id: 'oofSnsGkops',
  },
  {
    artist: 'Tropa de Elite',
    title: 'Tihuana',
    id: 'R7PqvzSwU9s',
  },
  {
    artist: 'MC Loma e as Gêmeas Lacração',
    title: 'Envolvimento',
    id: 'lgJOJAmXlBw',
  },
  {
    artist: 'Coldplay',
    title: 'Viva La Vida',
    id: 'dvgZkm1xWPE',
  },
  {
    artist: 'Fernanda Abreu',
    title: 'Rio 40 Graus',
    id: 'AhuJ3dUVQvc',
  },
  {
    artist: 'MC Guimê',
    title: 'País do Futebol',
    id: 'mQq6lIv8QjA',
  },
  {
    artist: 'Wolf Parade',
    title: "I'll Believe In Anything",
    id: '7G1eLTV89dM',
  },
  {
    artist: 'Ivete Sangalo',
    title: 'Sorte Grande',
    id: 'ZEaI-ZQ9yMs',
  },
  {
    artist: 'Bonnie Tyler',
    title: 'Holding Out For A Hero ',
    id: 'bWcASV2sey0',
  },
  {
    artist: 'Chimarruts',
    title: 'Do Lado de Cá',
    id: 'JQlKMX2LLHg',
  },

  {
    artist: 'The Feelies',
    title: 'Crazy Rhythms',
    id: '05GTWKu4uU8',
  },
  {
    artist: 'Laura Branigan',
    title: 'Gloria',
    id: 'nNEb2k_EmMg',
  },
  {
    artist: 'Juice Newton',
    title: 'Queen of Hearts',
    id: 'P0DK-0fIKCw',
  },
  {
    artist: 'Desireless',
    title: 'Voyage Voyage',
    id: 'wb_K0Omdfg0',
  },
  {
    artist: 'Rod Stewart',
    title: "I Don't Want To Talk About It",
    id: 'w46bWxS9IjY',
  },
  {
    artist: 'Metrô',
    title: 'Tudo pode mudar',
    id: 'nAjT4TCj9Fs',
  },
  {
    artist: 'Cyndi Lauper',
    title: 'Girls Just Want To Have Fun',
    id: 'PIb6AZdTr-A',
  },
  {
    artist: 'Olivia Newton-John, John Travolta',
    title: "You're The One That I Want",
    id: 'e__Pp4FxsjU',
  },
  {
    artist: 'ABBA',
    title: 'Lay all your love on me',
    id: 'Ln-Ua2teJKw',
  },
  {
    artist: 'Blondie',
    title: 'Maria',
    id: 'abw49k3rIN0',
  },
  {
    artist: 'Alizée',
    title: "J'ien ai marre!",
    id: 'G4LIM9VYhB0',
  },
  {
    artist: 'Karametade',
    title: 'Morango do Nordeste',
    id: '8-2ejxovclc',
  },
  {
    artist: 'Metro',
    title: 'Tudo Pode Mudar',
    id: 'rVS-O5wdNuQ',
  },
  {
    artist: 'Regina Spektor',
    title: 'Us',
    id: 'fczPlmz-Vug',
  },
  {
    artist: 'Cheiro de Amor/Carla Visi',
    title: 'Vai Sacudir, Vai Abalar',
    id: 'bEjaM9GbI6s',
  },
  {
    artist: 'Regina Spektor',
    title: "Don't Leave Me",
    id: 'BWXWivwhi14',
  },
  {
    artist: 'Banda Eva/Ivete Sangalo',
    title: 'Beleza Rara',
    id: 'I1cJnN-o7vU',
  },
  {
    artist: 'Thaeme e Thiago',
    title: 'Cafajeste',
    id: '4GnnRiezYd8',
  },
  {
    artist: 'Babado Novo',
    title: 'Bola De Sabão',
    id: '_w3AoEcImkw',
  },
  {
    artist: 'Roxette',
    title: 'It Must Have Been Love',
    id: 'k2C5TjS2sh4',
  },
  {
    artist: 'Vivo',
    title: '"DELEI" - O rapaz que vive atrasado',
    id: '3QaxlK4kolw',
  },
  {
    artist: 'Gaby Amarantos',
    title: 'Ex Mai Love',
    id: 's-5RfIXRIto',
  },
  {
    artist: 'Psirico',
    title: 'Lepo Lepo',
    id: 'AHVS5DW434g',
  },
  {
    artist: 'Banda Vingadora',
    title: 'Metralhadora',
    id: 'YzCoZGsod0c',
  },
  {
    artist: 'Malu e LUCAS',
    title: 'DISCO ARRANHADO',
    id: 'JisUmQmEqB8',
  },
  {
    artist: 'Luis Fonsi ft. Daddy Yankee',
    title: 'Despacito',
    id: 'kJQP7kiw5Fk',
  },
  {
    artist: 'Shakira ft. Pitbull',
    title: 'Rabiosa',
    id: 'a5irTX82olg',
  },
  {
    artist: 'Miley Cyrus',
    title: 'Party In The U.S.A.',
    id: 'M11SvDtPBhA',
  },
  {
    artist: 'Vengaboys',
    title: 'We like to Party!',
    id: '6Zbi0XmGtMw',
  },
  {
    artist: 'Giulia Be',
    title: 'menina solta',
    id: 'vz9XHsctOtc',
  },
  {
    artist: 'Caroline Jones',
    title: 'Rise',
    id: 'VqlwKBrrMXk',
  },
  {
    artist: 'Kelly Key',
    title: 'Cachorrinho',
    id: 'bANQVGy-wq4',
  },
  {
    artist: 'Spice Girls',
    title: 'Wannabe',
    id: 'gJLIiF15wjQ',
  },
  {
    artist: 'Aqua',
    title: 'Barbie Girl',
    id: 'ZyhrYis509A',
  },
  {
    artist: 'Loona',
    title: 'Parapapapapa',
    id: 'Q_NqQq51jaM',
  },
  {
    artist: 'Vengaboys',
    title: 'Boom Boom Boom',
    id: 'YKNkC6Sk7DU',
  },
  {
    artist: 'Carly Rae Jepsen',
    title: 'Call Me Maybe',
    id: 'fWNaR-rxAic',
  },
  {
    artist: 'Imagine Dragons',
    title: 'Radioactive',
    id: 'ktvTqknDobU',
  },
  {
    artist: 'Rednex',
    title: 'Cotton Eye Joe',
    id: 'mOYZaiDZ7BM',
  },
  {
    artist: 'Boom',
    title: 'How Do You Do',
    id: '23UGN3qqBWY',
  },
  {
    artist: 'Loretta Lynn, Conway Twitty',
    title: 'Louisiana Woman , Mississippi Man',
    id: '2Gd0tgGVPB0',
  },
  {
    artist: 'Avicii',
    title: 'Hey Brother',
    id: '6Cp6mKbRTQY',
  },
  {
    artist: 'OneRepublic',
    title: 'Counting Stars',
    id: 'hT_nvWreIhg',
  },
  {
    artist: 'David Guetta ft. Sia',
    title: 'Titanium',
    id: 'JRfuAukYTKg',
  },
  {
    artist: 'Ricky Martin',
    title: 'Livin La Vida Loca',
    id: 'p47fEXGabaY',
  },
  {
    artist: 'Las Ketchup',
    title: 'Aserejé',
    id: 'arZZw8NyPq8',
  },
  {
    artist: 'P!nk',
    title: 'Try',
    id: 'yTCDVfMz15M',
  },
  {
    artist: 'Latino',
    title: 'Renata',
    id: 'LnAJjRflHFE',
  },
  {
    artist: 'Perlla',
    title: 'Tremendo Vacilao',
    id: 'DN5_iOrJjfc',
  },
  {
    artist: 'Anastacia',
    title: 'Sick and Tired',
    id: 'CshDagHHzmI',
  },
  {
    artist: 'Anne Marie',
    title: 'Ciao Adios',
    id: 'FrA98gZGbDI',
  },
  {
    artist: 'Luka',
    title: 'Tô nem aí',
    id: 'vO8XQD6mHNg',
  },
  {
    artist: 'Charli XCX',
    title: 'Break The Rules',
    id: 'ABhDiXbUaBE',
  },
  {
    artist: 'Marcelo D2',
    title: 'Desabafar / Deixa Eu Dizer',
    id: 'fTGIHRT9KsI',
  },
  {
    artist: 'Shania Twain',
    title: 'Any Man Of Mine (Official Music Video)',
    id: '8N2k-gv6xNE',
  },
  {
    artist: 'Ananda',
    title: 'Quero Que Tu Vá',
    id: 'w_ejwSACf_U',
  },
  {
    artist: 'Jessie J ft. B.o.B',
    title: 'Price Tag',
    id: 'qMxX-QOV9tI',
  },
  {
    artist: 'Sean Kingston',
    title: 'Beautiful Girls',
    id: 'MrTz5xjmso4',
  },
  {
    artist: 'Joan Osborne',
    title: 'One Of Us',
    id: 'aDdOnl0bHO4',
  },
  {
    artist: 'Amy Winehouse',
    title: 'Rehab',
    id: 'KUmZp8pR1uc',
  },
  {
    artist: 'Amy Winehouse',
    title: 'Back To Black',
    id: 'TJAfLE39ZZ8',
  },
  {
    artist: 'Avril Lavigne',
    title: 'Complicated',
    id: '5NPBIwQyPWE',
  },
  {
    artist: 'Maroon 5',
    title: 'Sugar',
    id: '09R8_2nJtjg',
  },
  {
    artist: 'Camila Cabello ft. Young Thug',
    title: 'Havana',
    id: 'HCjNJDNzw8Y',
  },
  {
    artist: 'Twenty One Pilots',
    title: 'Ride',
    id: 'Pw-0pbY9JeU',
  },
  {
    artist: 'Loona',
    title: 'Vamos a la playa ',
    id: 'X-77txuiVXs',
  },
  {
    artist: 'Cherona',
    title: 'Rigga-Ding-Dong-Song',
    id: '3f43xmRqxOM',
  },
  {
    artist: 'Aqua',
    title: 'Cartoon Heroes',
    id: 'Q_LPJllaogU',
  },
  {
    artist: 'Red Hot Chili Peppers',
    title: 'Californication',
    id: 'YlUKcNNmywk',
  },
  {
    artist: 'Thaeme & Thiago',
    title: 'Ai que Dó',
    id: 'Ul4fQt4VvoA',
  },
  {
    artist: 'Kesha',
    title: 'Take It Off',
    id: 'edP0L6LQzZE',
  },
  {
    artist: 'Empreguetes',
    title: 'Vida De Empreguete',
    id: 'LuNexytb77g',
  },
  {
    artist: 'Jameika Mansur',
    title: 'Clima de Rodeio',
    id: '8rGgsN5RAmI',
  },
  {
    artist: 'Miranda Cosgrove',
    title: 'About You Now',
    id: 'AlIUNtQEI_s',
  },
  {
    artist: 'Miranda Cosgrove',
    title: 'Leave It All To Me',
    id: 'HPM05dQgdig',
  },
  {
    artist: 'Lily Allen',
    title: 'Not Fair',
    id: 'fUYaosyR4bE',
  },
  {
    artist: 'Roberta Campos',
    title: 'De Janeiro A Janeiro',
    id: 'J08WH4-4798',
  },
  {
    artist: 'Heart',
    title: 'Barracuda',
    id: 'PeMvMNpvB5M',
  },
  {
    artist: 'Legião Urbana',
    title: 'Faroeste Caboclo',
    id: 'qBIxI580dI8',
  },
  {
    artist: 'Social Distortion',
    title: 'Story of My Life',
    id: 'oh8zcbC_Dcw',
  },
  {
    artist: 'Poison',
    title: 'Talk Dirty To Me',
    id: 'xCChxBSRo1Y',
  },
  {
    artist: 'Journey',
    title: "Don't Stop Believin",
    id: 'VcjzHMhBtf0',
  },
  {
    artist: 'João Bosco & Vinícius',
    title: 'Chora, Me Liga',
    id: '6fJayNqtkM4',
  },
  {
    artist: 'Pat Benatar',
    title: 'Hit Me With Your Best Shot',
    id: 'JRD80XRMT7s',
  },
  {
    artist: 'Los Hermanos',
    title: 'Anna Júlia',
    id: 'umMIcZODm2k',
  },
  {
    artist: 'Victor & Leo',
    title: 'Fada',
    id: 'OqukL-DFYms',
  },
  {
    artist: 'Michel Teló',
    title: 'BARÁ BERÊ',
    id: 'gEiqSUzQ1fo',
  },
  {
    artist: 'The Animals',
    title: 'House of the Rising Sun',
    id: '4-43lLKaqBQ',
  },
  {
    artist: 'Linkin Park',
    title: 'In The End',
    id: 'eVTXPUF4Oz4',
  },
  {
    artist: 'Cynthia Erivo',
    title: 'Stand Up',
    id: 'NEMsIHVejWM',
  },
  {
    artist: 'The Verve',
    title: 'Bitter Sweet Symphony',
    id: '1lyu1KKwC74',
  },
  {
    artist: 'Pink Floyd',
    title: 'another brick in the wall',
    id: '5IpYOF4Hi6Q',
  },
  {
    artist: 'Queen',
    title: 'I want to break free',
    id: 'Kee9Et2j7DA',
  },

  {
    artist: 'LS Jack',
    title: 'Carla',
    id: 'EdZi3tZnbds',
  },
  {
    artist: 'O Surto',
    title: 'OA Cera',
    id: 'i0QCHeCoIz4',
  },
  {
    artist: 'Bonnie Tyler',
    title: "It's A Heartache",
    id: 'bEOl38y8Nj8',
  },
  {
    artist: 'Projota',
    title: 'Ela Só Quer Paz',
    id: 'SBs_pd1QQu8',
  },
  {
    artist: 'Don Henley',
    title: 'The Boys of Summer',
    id: 'DtxlvQqvDQs',
  },
  {
    artist: 'John Lennon',
    title: 'IMAGINE',
    id: 'YkgkThdzX-8',
  },
  {
    artist: 'The Beatles (reup)',
    title: 'Let It Be',
    id: 'QDYfEBY9NM4',
  },
  {
    artist: 'Blondie',
    title: 'Heart Of Glass',
    id: 'WGU_4-5RaxU',
  },
  {
    artist: 'Netinho',
    title: 'Milla',
    id: 'RYbl88mMMJw',
  },
  {
    artist: 'Kiss',
    title: 'Rock And Roll All Nite',
    id: 'EFMD7Usflbg',
  },
  {
    artist: 'MC Poze do Rodo',
    title: 'No Baile Nós É Mídia',
    id: 'WZIGwN-5Ioo',
  },
  {
    artist: 'Banda Djavú e DJ Juninho Portugal',
    title: 'Me Libera',
    id: 'lbP5s6c8NZw',
  },
  {
    artist: 'CPM 22',
    title: 'Um Minuto Para O Fim Do Mundo',
    id: 'RsEeyZNiwUk',
  },
  {
    artist: 'Victor & Leo',
    title: 'Borboletas',
    id: 'FxVRXGraRtc',
  },
  {
    artist: 'AronChupa, Little Sis Nora',
    title: "I'm an Albatraoz | ",
    id: 'Bznxx12Ptl0',
  },
  {
    artist: 'Pharrell Williams',
    title: 'Happy',
    id: 'ZbZSe6N_BXs',
  },
  {
    artist: 'Gordon Jenkins & His Orchestra, The Weavers',
    title: 'The Weavers Goodnight, Irene',
    id: 'MSDyiUBrUSk',
  },
  {
    artist: 'Munhoz & Mariano, João Neto & Frederico',
    title: 'BALADA LOUCA',
    id: 'ndb3uaGdy28',
  },

  {
    artist: 'ABBA',
    title: 'bba - Dancing Queen',
    id: 'xFrGuyw1V8s',
  },
  {
    artist: 'César Menotti & Fabiano',
    title: 'Ciumenta',
    id: 'TlYgdZTymkY',
  },
  {
    artist: 'César Menotti & Fabiano',
    title: 'Leilão',
    id: 'rS2FDyOKR2g',
  },
  {
    artist: 'Titãs',
    title: 'É Preciso Saber Viver',
    id: 'LpYj_sI79v8',
  },
  {
    artist: 'Gabriel Diniz',
    title: 'Jenifer',
    id: 'D2rG7pXd2LY',
  },
  {
    artist: 'Tiago Iorc',
    title: 'Amei Te Ver',
    id: 'W62-ZG9tPpI',
  },
  {
    artist: 'Beyoncé ft. JAY Z',
    title: 'Crazy In Love',
    id: 'ViwtNLUqkMY',
  },
  {
    artist: '4 Non Blondes',
    title: "What's Up",
    id: '6NXnxTNIWkc',
  },
  {
    artist: 'Bruno & Marrone',
    title: 'Dormi na Praça',
    id: 'uWX0O8ATY3k',
  },
  {
    artist: 'Cascada',
    title: 'Everytime We Touch',
    id: '4G6QDNC4jPs',
  },
  {
    artist: 'Alexandra Stan',
    title: 'Mr. Saxobeat',
    id: 'lAhHNCfA7NI',
  },
  {
    artist: 'Daddy Kall, Latino',
    title: 'Dança Kuduro',
    id: 'Rl35FK7fGU0',
  },
  {
    artist: 'Corona',
    title: 'The Rhythm of the Night',
    id: 'OnT58cIJSpw',
  },
  {
    artist: 'Maiara & Maraisa',
    title: 'Medo Bobo',
    id: 'Jzl_nrTkfIM',
  },
  {
    artist: 'Smile.dk, Smile',
    title: 'Butterfly',
    id: 'QzcvRDWgRIE',
  },
  {
    artist: 'Queen',
    title: 'Radio Ga Ga',
    id: 'azdwsXLmrHE',
  },
  {
    artist: 'Queen',
    title: 'Bohemian Rhapsody',
    id: 'fJ9rUzIMcZQ',
  },
  {
    artist: 'Kaoma',
    title: 'Lambada 1989 HD',
    id: 'iyLdoQGBchQ',
  },
  {
    artist: 'Eiffel 65',
    title: 'Blue (Da Ba Dee)',
    id: 'zA52uNzx7Y4',
  },
  {
    artist: 'The Killers',
    title: 'When You Were Young (Official Music Video)',
    id: 'ff0oWESdmH0',
  },
  {
    artist: 'Rouge',
    title: 'Ragatanga',
    id: 'eIpHQs6LDok',
  },
  {
    artist: 'Lipps Inc (reup)',
    title: 'Funkytown',
    id: 'uhzy7JaU2Zc',
  },
  {
    artist: 'Mamonas Assassinas',
    title: 'Pelados Em Santos',
    id: 'Nz7101ulkK0',
  },
  {
    artist: 'Thiago Brava Ft. Jorge',
    title: 'Dona Maria',
    id: 'qaPDDTLkB2U',
  },
  {
    artist: 'Creedence Clearwater Revival',
    title: 'Have You Ever Seen The Rain (Official)',
    id: 'u1V8YRJnr4Q',
  },
  {
    artist: 'Muse',
    title: 'Knights Of Cydonia',
    id: 'G_sBOsh-vyI',
  },
  {
    artist: 'Basshunter',
    title: 'Basshunter DotA',
    id: 'qTsaS1Tm-Ic',
  },
  {
    artist: 'Naiara Azevedo',
    title: 'Coitado',
    id: 'QlODF8Z5emo',
  },
  {
    artist: 'Tom Odell',
    title: 'Another Love',
    id: 'MwpMEbgC7DA',
  },
  {
    artist: 'George Harrison',
    title: 'My Sweet Lord',
    id: '04v-SdKeEpE',
  },
  {
    artist: 'Falamansa',
    title: 'Xote Da Alegria',
    id: '-1iKYof-C7o',
  },
];
